import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './shared/guards/auth.guard';
import { LandingDomainGuard } from './shared/guards/landing-domain.guard';
import { RedirectIfLoggedInGuard } from './shared/guards/redirect-auth.guard';

import { LandingLayoutComponent } from './landing/landing-layout.component';
import { AuthLayoutComponent } from './auth/auth-layout.component';
import { WorkspaceLayoutComponent } from './workspace/workspace-layout.component';
import { CompanyLayoutComponent } from './company/company-layout.component';
import { DashboardLayoutComponent } from './dashboard/dashboard-layout.component';

import { HowToGuidePageComponent } from './general/how-to-guide-page/how-to-guide-page.component';
import { ContactsPageComponent } from './general/contacts-page/contacts-page.component';
import { TermsPageComponent } from './general/terms-page/terms-page.component';
import { CookiesPolicyPageComponent } from './general/cookies-policy-page/cookies-policy-page.component';
import { PrivacyPolicyPageComponent } from './general/privacy-policy-page/privacy-policy-page.component';
import { UserProfileEditPageComponent } from './general/user-profile-edit-page/user-profile-edit-page.component';
import { CompanyAuthGuard } from './shared/guards/company-auth.guard';
import { LOCAL_STORAGE_KEYS } from './shared/constants';

const routes: Routes = [
  {
    path: '',
    component: LandingLayoutComponent,
    canActivate: [LandingDomainGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./landing/landing.module').then((m) => m.LandingModule)
      }
    ]
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule)
      }
    ]
  },
  {
    // backward compatibility route. Redirects to /workspace/:activeCompanyId
    path: 'workspace',
    pathMatch: 'full',
    redirectTo: (route) => {
      const companyId = localStorage.getItem(LOCAL_STORAGE_KEYS.ACTIVE_COMPANY_ID);

      if (companyId === null) {
        return `/dashboard`;
      }

      return `/workspace/${companyId}`;
    }
  },
  {
    path: 'workspace/:companyId',
    component: WorkspaceLayoutComponent,
    canActivate: [AuthGuard, CompanyAuthGuard],
    runGuardsAndResolvers: 'pathParamsChange',
    children: [
      {
        path: '',
        loadChildren: () => import('./workspace/workspace.module').then((m) => m.WorkspaceModule)
      }
    ]
  },
  {
    // backward compatibility route. Redirects to /company/:activeCompanyId
    path: 'company',
    pathMatch: 'full',
    redirectTo: (route) => {
      const companyId = localStorage.getItem(LOCAL_STORAGE_KEYS.ACTIVE_COMPANY_ID);

      if (companyId === null) {
        return `/dashboard`;
      }

      return `/company/${companyId}`;
    }
  },
  {
    path: 'company/:companyId',
    component: CompanyLayoutComponent,
    canActivate: [AuthGuard, CompanyAuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./company/company.module').then((m) => m.CompanyModule)
      }
    ]
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule)
      }
    ]
  },
  {
    path: 'user-profile',
    component: UserProfileEditPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'how-to-guide',
    component: HowToGuidePageComponent
  },
  {
    path: 'contacts',
    component: ContactsPageComponent
  },
  {
    path: 'terms-and-conditions',
    component: TermsPageComponent
  },
  {
    path: 'cookie-policy',
    component: CookiesPolicyPageComponent
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyPageComponent
  },
  { path: '**', redirectTo: '/auth/login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
